import styled from 'styled-components';

export const StyledActionItem = styled.div`
  margin-right: 0.5rem;
  margin-left: 1.5rem;
`;

export const StyledActions = styled.div`
  display: flex;
  align-items: center;
  & #CloseIcon {
    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }
`;
